import React from "react";
import Index from "../routes/Index";
import "./App.scss";
import { UserProvider } from "../context/UserContext";
import { FormDataProvider } from "../context/FormDataContext";
import { NowlunFormProvider } from "../context/NowlunFormContext"

const App = () => {
  return (
    <div className="App">
      <UserProvider>
        <FormDataProvider>
          <NowlunFormProvider>
            <Index />
          </NowlunFormProvider>
        </FormDataProvider>
      </UserProvider>
    </div>
  );
};

export default App;